<template>
  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"
    ></path>
    <polyline
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      points="9,22 9,12 15,12 15,22"
    ></polyline>
  </svg>
</template>
